import './accordion.module.scss';
import MaterialAccordion from '@mui/material/Accordion';
import MaterialAccordionDetails from '@mui/material/AccordionDetails';
import MaterialAccordionSummary from '@mui/material/AccordionSummary';
import MaterialAccordionActions from '@mui/material/AccordionActions';

/* eslint-disable-next-line */
export interface AccordionProps {
  children: any,
  // classes?: object,
  defaultExpanded?: boolean,
  disabled?: boolean,
  disableGutters?: boolean,
  expanded?: boolean,
  onChange?: (event: any, checked: boolean) => void,
  square?: boolean,
  sx?: any,
  // TransitionComponent?: any,
  // TransitionProps?: object
  title?: string
}

export interface AccordionDetailsProps {
  children?: any,
  // classes?: object,
  sx?: any
}

export interface AccordionSummaryProps {
  children?: any,
  classes?: object,
  expandIcon?: any,
  // focusVisibleClassName?: string,
  sx?: any
}

export interface AccordionActionsProps {
  children: any,
  // classes?: object,
  // disableSpacing?: boolean,
  sx?: any
}

export function Accordion(props: AccordionProps) {
  return (
    <MaterialAccordion
      disabled={props.disabled}
      disableGutters={props.disableGutters}
      defaultExpanded={props.defaultExpanded}
      expanded={props.expanded}
      onChange={props.onChange}
      square={props.square}>
      {props.children}
    </MaterialAccordion>
  );
}

export function AccordionDetails(props: AccordionDetailsProps) {
  return (
    <MaterialAccordionDetails
      sx={props.sx}>
      {props.children}
    </MaterialAccordionDetails>
  );
}

export function AccordionSummary(props: AccordionSummaryProps) {
  return (
    <MaterialAccordionSummary
      expandIcon={props.expandIcon}>
      {props.children}
    </MaterialAccordionSummary>
  );
}

export function AccordionActions(props: AccordionActionsProps) {
  return (
    <MaterialAccordionActions
      sx={props.sx}>
      {props.children}
    </MaterialAccordionActions>
  );
}

export default Accordion;